import React, { useEffect, useState } from "react";
import { Button, Badge, Col, Form, Modal, Row } from "react-bootstrap";

/**
 * @param {Object} props
 * @param {Object} props.details
 * @param {Function} props.handleSnackOpen
 * @param {Function} props.submitNotes
 * @param {Function} props.onHide
 * @param {Array<Object>} props.templates
 */
function ReleaseNotesModal(props) {
  const [messageText, setMessageText] = useState("");
  const [contactSupport, setContactSupport] = useState(false);
  const [resolved, setResolved] = useState(false);
  const [clinicianName, setClinicianName] = useState(props?.details?.primaryClinicianName);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    setClinicianName(props?.details?.primaryClinicianName);
  }, [props?.details]);

  const [testType, setTestType] = useState("");
  const [genderType, setGenderType] = useState("");
  const TEMPLATE = props.templates;

  const submitSaveDraft = () => {
    if (messageText !== "") {
      props.submitNotes("external", messageText, false);
      props.onHide();
    }
  };

  const submitReleaseNotes = () => {
    if (messageText !== "") {
      // props.submitNotes("external", messageText, true);
      // props.onHide();
      setShowConfirmationModal(true);
    }
  };

  const handleTemplateApplication = async e => {
    let currGenderType = e.target.value;
    let selectedOne = testType?.types?.find(testType => testType.name === currGenderType);
    setGenderType(currGenderType);

    const patientName = props.details?.firstName + " " + props.details?.lastName;
    if (!selectedOne?.name || !selectedOne?.content) {
      alert("There was an error applying the template. Please reset & try again.");
      return;
    }
    if (!patientName) {
      window.confirm("There was an error fetching Patient's Name Automatically, please go ahead and manually enter patient name in the message.");
    }
    if (!clinicianName) {
      window.confirm(
        "We noticed you haven't entered your name in Profile Details. Please make sure to fill your details in Profile Page or please manually enter your name/signature in the message."
      );
    }

    let message = selectedOne?.content?.replace(/{{patientName}}/g, patientName);
    message = message?.replace(/{{clinicianName}}/g, clinicianName);
    setMessageText(message);
  };

  const getTitle = () => {
    return props.isBookingSendPatientSummary === true ? "Send Patient Summary" : "Send Results";
  }

  const handleClearAndClose = () => {
    setMessageText("");
    setGenderType("");
    setTestType();
    props.onHide();
  };

  const resetTemplate = () => {
    setTestType();
    setGenderType("");
  };
  const confirmSendToPatient = () => {
    if (messageText !== "") {
      props.submitNotes("external", messageText, true);
      props.onHide();
    }
    setShowConfirmationModal(false);
  };


  return (
    <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
         <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to send this message to the patient?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmationModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmSendToPatient}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Form id={"sendMessageForm"}>
        <Modal.Header id="modalHeader">
          <Modal.Title>{getTitle()}</Modal.Title>
        </Modal.Header>
        {!contactSupport && (
          <>
            <Modal.Body id="modalBody">
              <Form.Group controlId="formLink">
                <Row>
                  <Col style={{ flex: 1.6 }}>
                    <Form.Label>Message Preview</Form.Label>
                    <Form.Control
                      style={{ border: "1px solid lightgray", background: "rgba(0,0,0,0.05)" }}
                      as="textarea"
                      rows={10}
                      value={messageText}
                      onChange={e => setMessageText(e.target.value)}
                    />
                  </Col>
                  <Col style={{ flex: 0.4 }}>
                    <b>Patient Demographic Details</b>
                    <div style={{ textAlign: "left" }}>
                      Name : &nbsp; {props.details?.firstName} {props.details?.lastName}
                    </div>
                    <div style={{ textAlign: "left" }}>Email : &nbsp; {props.details?.email}</div>
                    <div style={{ textAlign: "left" }}>Phone : &nbsp; {props.details?.phone}</div>
                    <div style={{ textAlign: "left" }}>State : &nbsp; {props.details?.state}</div>
                    <div style={{ textAlign: "left" }}>DOB : &nbsp; {props.details?.dob}</div>
                    <div style={{ textAlign: "left" }}>Sex Assigned : &nbsp; {props.details?.genderAtBirth}</div>
                  </Col>
                </Row>
                <hr></hr>
                <Row style={{ display: "flex", justifyContent: "space-around", marginLeft: 0 }} className="TestResult ">
                  {TEMPLATE?.length && (
                    <Col className="pb-3" style={{ background: "#866BD9", maxWidth: 250, borderRadius: 10 }}>
                      <h4 style={{ width: "100%", textAlign: "center", paddingTop: 8 }}>Templates</h4>
                      <Col>
                        <Form.Select
                          value={testType?.name || ""}
                          onChange={e => {
                            const test = TEMPLATE?.find(item => item.name === e.target.value);
                            setTestType(test);
                            setGenderType("");
                          }}
                          style={{ width: "100%", height: 30, borderRadius: 5, background: "white", marginTop: 10 }}
                        >
                          <option value="" default disabled>
                            Select Test
                          </option>
                          {TEMPLATE?.map((test, ind) => {
                            return (
                              <option key={ind} value={test.name}>
                                {test.name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {testType?.types?.length && (
                          <Form.Select
                            value={genderType || ""}
                            onChange={handleTemplateApplication}
                            style={{ width: "100%", height: 30, borderRadius: 5, background: "white", marginTop: 10 }}
                          >
                            <option value="" default disabled>
                              Select Template
                            </option>
                            {testType?.types?.map((fid, ind) => {
                              return (
                                <option key={ind} value={fid.name}>
                                  {fid.name}
                                </option>
                              );
                            })}
                          </Form.Select>
                        )}
                      </Col>
                      {testType && (
                        <div
                          style={{ cursor: "pointer", width: "100%", marginLeft: 5, marginRight: 5, paddingTop: 10, textAlign: "center" }}
                          onClick={resetTemplate}
                        >
                          <u>Reset</u>
                        </div>
                      )}
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Col
                style={{
                  display: "flex",
                  flexDirection:"column",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                  width: "100%",
                  padding: 0,
                  margin: 0,
                }}
              >
                <div>
                  <p
                    style={{
                      color: "red",
                    }}
                  >
                    This summary will be sent to Patient</p>
                </div>
                <div>
                  <Button variant="light" type="button" onClick={handleClearAndClose}>
                    Cancel
                  </Button>
                  {/* <Button id="msg_reply" class="replyButton sendButton text-right" onClick={() => submitSaveDraft()}>
                Save Draft
              </Button> */}
                  <Button id="msg_reply" class="replyButton sendButton text-right ml-4" onClick={() => submitReleaseNotes()}>
                    Send to Patient <i className="fa fa-paper-plane" aria-hidden="true"></i>
                  </Button>
                </div>
              </Col>
            </Modal.Footer>
          </>
        )}
        {contactSupport && (
          <>
            <Modal.Body className="onboard-modal">
              <h2 className="mb-20 text-center">Some results were rejected and/or the specimen was not provided. Contact support for next steps.</h2>
              <div className="flex align-item-center">
                <Form.Check
                  className="mr-20"
                  checked={resolved}
                  type="checkbox"
                  label="This has been resolved"
                  onChange={e => setResolved(!resolved)}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                id="msg_reply"
                class="replyButton sendButton text-right"
                onClick={() => {
                  if (resolved) {
                    setContactSupport(false);
                  } else {
                    props.handleSnackOpen("you must check that this has been resolved before moving on", "error");
                  }
                }}
              >
                Send <i className="fa fa-paper-plane" aria-hidden="true"></i>
              </Button>
            </Modal.Footer>
          </>
        )}
      </Form>
    </Modal>
  );
}

export default ReleaseNotesModal;
